import React, { useState, useEffect } from 'react';
import { Add, Minus } from 'iconsax-react';
import logo from '../../assets/img/logo.png';
import logo2 from '../../assets/img/logo/brand-crest_dark.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../actions/auth';
import { useDispatch } from 'react-redux';
import { Offcanvas } from 'bootstrap';

function Header() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  const token = localStorage.getItem('token');

  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL || 'https://app.cardplot.com';
  
  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const getMobileMenu = () => {
    const menuElement = document.getElementById('offcanvasExample');
    return menuElement ? Offcanvas.getOrCreateInstance(menuElement) : null;
  };

  const openMobileMenu = () => {
    getMobileMenu()?.show();
  };

  const handleMobileMenuLink = (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    const destination = link.getAttribute('href');
    const target = link.getAttribute('target');

    setOpenDropdown(null);

    if (destination && target !== '_blank') {
      const url = new URL(destination, window.location.origin);
      if (url.origin === window.location.origin) {
        event.preventDefault();
        navigate(`${url.pathname}${url.search}${url.hash}`);
      }
    }

    // Let the selected link finish navigating before dismissing the sidebar.
    window.setTimeout(() => {
      getMobileMenu()?.hide();
    }, 0);
  };

  // Reset dropdown state on location change
  useEffect(() => {
    setOpenDropdown(null);
  }, [location]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.drop__item')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleLogout = async () => {

    // const token = localStorage.getItem('token');
    // const email = localStorage.getItem('userEmail'); 

    if (!token) {
      console.error("User credentials missing!");
      return;
    }

    // const credentials = { token, email };

    try {
      await logout(token, navigate, dispatch);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const maintenance = process.env.REACT_APP_ENVIRONMENT == 'maintenance';

  return (
    <>
      <header className='header'>
        <div className='header__container'>
          <div className='header__right'>
            <div className="brand__logo">
              <Link to='/' className='header__logo'>
                <img src={logo} className='logo' alt='logo' />
              </Link>
            </div>
            <div className="header-toggle d-lg-none">
              <button type="button" onClick={openMobileMenu} aria-label="Open navigation menu">
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div> 
          </div>
          <nav className='header__nav d-none d-lg-block'>
              <ul className='header__list'>
                {/* Company Dropdown */}
                <li className='header__item drop__item'>
                  <span
                    className='header__link drop__link'
                    onClick={() => toggleDropdown('Company')}
                  >
                    Company
                  </span>
                  {openDropdown === 'Company' && (
                    <ul className='header__dropdown'>
                      <li className='header__dropdown__item'><Link to='/about'>About us</Link></li>
                      <li className='header__dropdown__item'><Link to='/how-it-works'>How it works</Link></li>
                      <li className='header__dropdown__item'><Link to=''>Partners</Link></li>
                      <li className='header__dropdown__item'><Link to=''>Customers</Link></li>
                    </ul>
                  )}
                </li>

                <li className='header__item'>
                  <Link to='https://blog.cardplot.com/' className='header__link'>News & Blog</Link>
                </li> 
                {/* Features Dropdown */}
                <li className='header__item drop__item'>
                  <span
                    className='header__link drop__link'
                    onClick={() => toggleDropdown('Features')}
                  >
                    Features
                  </span>
                  {openDropdown === 'Features' && (
                    <ul className='header__dropdown'>
                      <li className='header__dropdown__item'><Link to='/virtual-account'>Virtual Account</Link></li>
                      <li className='header__dropdown__item'><Link to='/virtual-card'>Virtual Card</Link></li>
                      <li className='header__dropdown__item'><Link to='/send-money'>Send Money</Link></li>
                      <li className='header__dropdown__item'><Link to='/payment-link'>Payment Links</Link></li>
                      <li className='header__dropdown__item'><Link to='/airtime-bill-payment'>Airtime & Bill Payments</Link></li>
                      <li className='header__dropdown__item'><Link to='/business-account'>Business Account</Link></li>
                    </ul>
                  )}
                </li>

                <li className='header__item'>
                  <Link to='/contact' className='header__link'>Contact us</Link>
                </li>

                {/* Resources Dropdown */}
                <li className='header__item drop__item'>
                  <span
                    className='header__link drop__link'
                    onClick={() => toggleDropdown('Resources')}
                  >
                    Resources
                  </span>
                  {openDropdown === 'Resources' && (
                    <ul className='header__dropdown'>
                      <li className='header__dropdown__item'><Link to='/help'>Help Centre</Link></li>
                      <li className='header__dropdown__item'><Link to='/faq'>FAQs</Link></li> 
                      <li className='header__dropdown__item'><Link to='/pricing' className='header__link'>Pricing</Link></li>
                      <li className='header__dropdown__item'><Link to='/leaderboard'>Leaderboard</Link></li>
                      <li className='header__dropdown__item'><Link to='/career'>Careers</Link></li>
                      <li className='header__dropdown__item'><Link to='/legal'>Legal</Link></li>
                    </ul>
                  )}
                </li>
              </ul>
            </nav>
          {!maintenance &&
            <div className='header__left'>
              <>
                <a className='header__btn__login' href={`${dashboardBaseUrl}/login`} target="_blank" rel="noopener noreferrer">
                  Login
                </a>
                <a className='header__btn__get__started' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
              </>
              {/* <div className='header__language drop__lang'>
                  <span
                    className='language__btn'
                    onClick={() => toggleDropdown('Languages')}
                  >
                    EN
                  </span>
                  {openDropdown === 'Languages' && (
                    <ul className='language__dropdown'>
                      <li className='language__dropdown__item'>English</li>
                      <li className='language__dropdown__item'>Francais</li>
                      <li className='language__dropdown__item'>Espanol</li>
                      <li className='language__dropdown__item'>عربي</li>
                      <li className='language__dropdown__item'>Zulu</li>
                      <li className='language__dropdown__item'>Swahili</li>
                    </ul>
                  )}
                </div> */}
            </div>
          }
        </div>
      </header>

      {/* offcanvas menu */}
      <div
        className="mobile__menu offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
        onClickCapture={handleMobileMenuLink}
      >
        <div className="offcanvas-header">
          <div className="header-menu-wrapper align-items-center d-flex gap-2">
            <div className="logo-wrapper">
              <Link to='/' className="normal-logo" id="offcanvas-logo-normal" data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>
                <img src={logo} className='logo img-fluid' alt='logo' />
              </Link>
            </div>
          </div>
          <button type="button" className="btn-close opacity-100" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          <div className="offcanvas-menu">
            <ul className="side-Nav main-menu ">
              {/* Company Dropdown */}
              <li className='header__item drop__item'>
                <div className='header__link drop__link ' onClick={() => toggleDropdown('Company')} tabIndex="0" role="button">
                  Company
                  <span onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering parent click event
                    toggleDropdown('Company');
                  }}>
                    {openDropdown === 'Company' ? (
                      <Minus
                        className='menu-expand'

                      />
                    ) : (
                      <Add
                        className='menu-expand'

                      />
                    )}
                  </span>

                </div>
                {openDropdown === 'Company' && (
                  <ul className='header__dropdown'>
                    <li className='header__dropdown__item'><Link to='/about' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>About us</Link></li>
                    <li className='header__dropdown__item'><Link to='/how-it-works' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>How it works</Link></li>
                    <li className='header__dropdown__item'><Link to='' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Partners</Link></li>
                    <li className='header__dropdown__item'><Link to='' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Customers</Link></li>
                  </ul>
                )}
              </li>

              <li className='header__item'>
                <Link to='/pricing' className='header__link' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Pricing</Link>
              </li>

              {/* Features Dropdown */}
              <li className='header__item drop__item'>
                <div className='header__link drop__link' onClick={() => toggleDropdown('Features')}>
                  Features
                  <span onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering parent click event
                    toggleDropdown('Features');
                  }}>
                    {openDropdown === 'Features' ? (
                      <Minus
                        className='menu-expand'

                      />
                    ) : (
                      <Add
                        className='menu-expand'

                      />
                    )}
                  </span>
                </div>
                {openDropdown === 'Features' && (
                  <ul className='header__dropdown'>
                    <li className='header__dropdown__item'><Link to='/virtual-account' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Virtual Account</Link></li>
                    <li className='header__dropdown__item'><Link to='/virtual-card' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Virtual Card</Link></li>
                    <li className='header__dropdown__item'><Link to='/send-money' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Send Money</Link></li>
                    <li className='header__dropdown__item'><Link to='/payment-link' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Payment Links</Link></li>
                    <li className='header__dropdown__item'><Link to='/airtime-bill-payment' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Airtime & Bill Payments</Link></li>
                    <li className='header__dropdown__item'><Link to='/business-account' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Business Account</Link></li>
                  </ul>
                )}
              </li>

              <li className='header__item'>
                <Link to='/contact' className='header__link'>Contact us</Link>
              </li>

              {/* Resources Dropdown */}
              <li className='header__item drop__item'>
                <div className='header__link drop__link' onClick={() => toggleDropdown('Resources')}>
                  Resources
                  <span onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering parent click event
                    toggleDropdown('Resources');
                  }}>
                    {openDropdown === 'Resources' ? (
                      <Minus
                        className='menu-expand'

                      />
                    ) : (
                      <Add
                        className='menu-expand'

                      />
                    )}
                  </span>
                </div>
                {openDropdown === 'Resources' && (
                  <ul className='header__dropdown'>
                    <li className='header__dropdown__item'><Link to='/help' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Help Centre</Link></li>
                    <li className='header__dropdown__item'><Link to='/faq' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>FAQs</Link></li>
                    <li className='header__dropdown__item'><Link to='https://blog.cardplot.com/' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>News & Blog</Link></li>
                    <li className='header__dropdown__item'><Link to='/career' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Careers</Link></li>
                    <li className='header__dropdown__item'><Link to='/legal' data-bs-dismiss="offcanvas" onClick={() => setOpenDropdown(null)}>Legal</Link></li>
                  </ul>
                )}
              </li>
            </ul>

            <div className="auth__menu__actions d-flex align-items-center justify-content-center gap-3 mt-5 p-2">
              <>
                <a
                  className='header__btn__login'
                  href={`${dashboardBaseUrl}/login`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpenDropdown(null)}
                >
                  Login
                </a>
                <a
                  className='header__btn__get__started'
                  href={`${dashboardBaseUrl}/getstarted`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpenDropdown(null)}
                >
                  Get Started
                </a>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default Header;
